import classNames from 'classnames';
import Icon from 'components/icon/icon';
import Img, { ImgProps } from 'components/img/img';
import parse from 'html-react-parser';
import React from 'react';
import ButtonLink from 'components/buttonLink/buttonLink';
import './teamGridSimpleMember.scss';
import 'components/share/shareBar.scss';

export interface TeamGridMemberProps {
  title: string;
  content: string;
  slug: string;
  teamMember: {
    position?: string;
    title?: string;
    contactSocial?: {
      platform: string;
      link: string;
    }[];
    cv?: {
      mediaItemUrl: string;
    };
  };
  featuredImage?: {
    node: ImgProps;
  };
}

const TeamGridMember: React.FC<TeamGridMemberProps> = (props) => {
  const renderShareBar = () => {
    return (
      <div className="lg:invisible group-hover:visible">
        <div className="flex justify-center">
          <div className="flex">
            {props.teamMember.contactSocial?.map((item, key) => (
              <a
                href={item.link.includes('@') && !item.link.includes('mailto:') ? `mailto:${item.link}` : item.link}
                target="_blank"
                rel="norefferer"
                className="share-bar-item"
                key={key}
              >
                <Icon icon={item.platform} size="20" />
              </a>
            ))}
          </div>
          {!!props.teamMember.cv && <ButtonLink file={props.teamMember.cv} label="CV" />}
        </div>
      </div>
    );
  };

  return (
    <div className="team-grid-simple-member group">
      {!!props.featuredImage && <Img className="block w-8/12 tablet:w-full mx-auto rounded-full" {...props.featuredImage.node} />}
      <div className="mt-6 max-h-full text-center leading-[1.6]">
        <h4 className="mb-2">{props.title}</h4>
        {!!props.teamMember.title && <div className="team-grid-member__title">{props.teamMember.title}</div>}
        {!!props.teamMember.position && <div className="team-grid-member__position">{props.teamMember.position}</div>}
        {
          <div className="team-grid-simple-member__text">
            {!!props.content && parse(props.content)}
            {!!props.teamMember.contactSocial?.length && renderShareBar()}
          </div>
        }
      </div>
    </div>
  );
};

export default TeamGridMember;
